
import { defineComponent } from 'vue';
import { useTopCurrencies } from '@/composables/useTopCurrencies';
import TopCurrenciesTable from '@/components/TopCurrenciesTable.vue';

export default defineComponent({
  name: 'TopCurrencies',
  components: {
    TopCurrenciesTable,
  },
  setup() {
    const { currencies, searchQuery } = useTopCurrencies();
    return { currencies, searchQuery };
  },
});
